import { IconWrapper } from '../runtime';
export default IconWrapper('s2t_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#6964FA"
    }
  }), h("path", {
    "attrs": {
      "d": "M2 16C0.895431 16 0 15.1046 0 14L16 14C16 15.1046 15.1046 16 14 16L2 16Z",
      "fill": "#5651E6"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 16L8 14L16 14C16 15.1046 15.1046 16 14 16L8 16Z",
      "fill": "#817CFF"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8.8008 4V6C8.8008 6.44183 8.44263 6.8 8.0008 6.8C7.55897 6.8 7.2008 6.44183 7.2008 6V4C7.2008 3.55817 7.55897 3.2 8.0008 3.2C8.44263 3.2 8.8008 3.55817 8.8008 4ZM6.0008 4C6.0008 2.89543 6.89623 2 8.0008 2C9.10537 2 10.0008 2.89543 10.0008 4V6C10.0008 7.10457 9.10537 8 8.0008 8C6.89623 8 6.0008 7.10457 6.0008 6V4ZM4.81709 6H3.61328C3.75403 8.0903 5.3546 9.78049 7.404 10.0596V12H8.604V10.0594C10.6527 9.77966 12.2525 8.08978 12.3932 6H11.1894C11.0381 7.62665 9.6694 8.90002 8.00324 8.90002C6.33708 8.90002 4.96833 7.62665 4.81709 6Z",
      "fill": "white"
    }
  })]);
});